import bootstrap from "../shared/bootstrap";
import loginRoutes from "../routes/login";
import { initI18n } from "../shared/i18n";

// The auth screens only need the shared namespace (login + password keys).
initI18n(["common"]);

bootstrap({ routes: loginRoutes });
